import { FaCircleCheck } from 'react-icons/fa6';
import { PiCalendarBlank, PiClock } from 'react-icons/pi';
import { CiClock2 } from 'react-icons/ci';
import moment from 'moment';


const RightSidePlacementDriveDetails = ({ driveRegistrationApplication }: { driveRegistrationApplication: any }) => {

	const driveDetails = {
		driveDate: moment(driveRegistrationApplication?.driveDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ'),
		driveEndDate: moment(driveRegistrationApplication?.driveEndDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ'),
		duration: '8am - 6pm',
		driveLocation: driveRegistrationApplication?.location,
		address: `${driveRegistrationApplication?.city}, ${driveRegistrationApplication?.location}`,
	};

	const features = [
		'Fast-track hiring with 50+ companies and same-day offers.',
		'6,000+ placements with ₹6.1 LPA average and ₹36 LPA highest CTC.',
		'Skill-based, unbiased recruitment process.',
		'Inclusive opportunities for all backgrounds.',
	];

	const companyLogos = [
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/image1623_ezgif_com_png_to_webp_converter_6f040b27d8.webp',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/image1625_ezgif_com_png_to_webp_converter_3fa906629f.webp',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/image1624_ezgif_com_png_to_webp_converter_8bfd239102.webp',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/image10_ezgif_com_png_to_webp_converter_a02e417345.webp',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/image1626_ezgif_com_png_to_webp_converter_ea84936c20.webp',
	];
	return (
		<div className="p-4 flex items-center justify-start flex-col bg-white rounded-[12px] border border-[#E7E6E6] shadow-[0px_4px_2px_0px_rgba(0,_0,_0,_0.05)]">
			<div className="flex gap-4 border-b-[1px] w-full border-[#E7E6E6] pb-4">
				<div className="rounded-lg flex items-center justify-center">
					<img
						className="w-full text-violet-500 object-contain"
						src="https://masai-website-images.s3.ap-south-1.amazonaws.com/Course_icon_ezgif_com_png_to_webp_converter_057da79213.webp"
						alt=""
					/>
				</div>

				<div className={`${driveRegistrationApplication?.driveDate ? "flex-1" : "flex items-center"}`}>
					<h1 className="text-[#192335] font-inter text-[20px] font-bold leading-[28px]">Placement Drive</h1>
					{driveRegistrationApplication?.driveDate ? (
						<div className='space-y-1 mt-1'>
							<div className="flex items-center gap-2 text-[#21191B]">
								<PiCalendarBlank className="w-5 h-5" />
								<span className='text-[#21191B] text-[12px] font-inter leading-[20px] font-[600]'>
									{driveRegistrationApplication?.driveDate && driveDetails?.driveDate ?
										`${driveDetails?.driveDate.format(`${driveDetails?.driveEndDate.isValid() ? 'Do' : 'Do MMM'}`)}${driveDetails?.driveEndDate && driveDetails?.driveEndDate.isValid() ? ` - ${driveDetails?.driveEndDate.format('Do MMM')}` : ''}`
										: '-'}
								</span>
								{/* • {driveDetails?.duration} */}
							</div>
							<div className="flex items-center gap-2">
								<CiClock2 className="w-5 h-5" />
								<span className='text-[#21191B] text-[12px] font-inter leading-[20px] font-[600]'>{driveRegistrationApplication?.driveDate && driveDetails?.address ? driveDetails?.address : '-'}</span>
							</div>
						</div>
					) : ""}
				</div>
			</div>

			<div className="space-y-3 mt-6">
				{(driveRegistrationApplication?.driveDetails?.meta?.driveSellingPoints?.length > 0
					? driveRegistrationApplication.driveDetails.meta.driveSellingPoints
					: features
				).map((benefit: string, index: number) => (
					<div key={index} className="flex items-start gap-2">
						<div className="bg-[#6FCD9E] rounded-full">
							<FaCircleCheck color="#EEFFF7" size="24px" />
						</div>
						<span className="text-gray-700">{benefit}</span>
					</div>
				))}
			</div>

			<div className="mt-8">
				<h2 className="text-gray-600 mb-4">Companies Hiring</h2>
				<div className="flex justify-center flex-wrap gap-4 mt-4">
					{(driveRegistrationApplication?.driveDetails?.meta?.hiringCompaniesImages?.length > 0
						? driveRegistrationApplication.driveDetails.meta.hiringCompaniesImages
						: companyLogos
					).map((logo: string, index: number) => (
						<img key={index} src={logo} alt="Company Logo" className="h-12 object-contain" />
					))}
				</div>
				<p className="text-center text-gray-600 mt-4">& more</p>
			</div>
		</div>
	);
};

export default RightSidePlacementDriveDetails;
